import React from 'react';
import './custom.css'
import MyVerticallyCenteredModal from './EventModal';
import 'aos/dist/aos.css';
import AOS from 'aos';
const About = () => {
    const [modalShow, setModalShow] = React.useState(false);
    AOS.init({
        duration: 1200,
    });
    return (
        <>
            <section id='theClub' className='mx-md-5 mx-3 marTa'>
                <div className='row g-5'>
                    <div className='d-none d-md-block col-md-6 videoEdit'>
                        <video className='w-100 mt-5' src='/img/valtus.mp4' autoPlay controls></video>
                    </div>
                    <div className='col-md-6'>
                        <h1 data-aos="flip-up" className='about_header'>About O2 Club</h1>
                        <div>
                            <span className='about_span'>A decentralized global citizens club</span>
                            <div className='about_para' >
                                <p className='minig_text' data-aos="fade-up" data-aos-duration="2000">O2Club is connecting global citizens from all around ​the world that place the well being of the planet at high priority. Their actions can create ripple effects that inspire and ​motivate collective actions, moving us towards the ​systemic change we need to tackle an issue like ​climate change.
                                    O2Club is not just a community club but a financial ​ecosystem.  They do good, and get rewards and recognition. Membership of the Club features benefits from time to time such as Voting rights, Mining rights, Monetisation of carbon reduction and data, Deals, Better mobility, Global recognition.
                                </p>
                            </div>

                            <div data-aos="fade-up" data-aos-duration="2000" className='about_btn'>
                                <button
                                    onClick={() => setModalShow(true)}
                                    className='aboutBtnn'>
                                    Join the club
                                </button>

                            </div>
                            <div className='d-block d-md-none col-md-6 videoEdit'>
                                <video className='w-100 mt-5' src='/img/valtus.mp4' autoPlay controls></video>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
};

export default About;